export enum PlanTypes {
  ConciergeCare = 'cc',
  FlexCare = 'fc',
  LifeMDMembership = 'p',
  LifeMDPlus = 'lmp',
  MentalHealth = 'mh',
  NotSelected = 'n',
  TotalCare = 'tc',
  UnlimitedPlan = 'u',
  UrgentCare = 'uc',
  WeightManagement = 'w'
}

export enum FlowTypes {
  BlueLineFlow = 'bl',
  TripleTherapy = 'tt',
  WeightManagementBalladHealth = 'wm-ballad-health',
  WeightManagementBenefitsCheckNew = 'rtb',
  WeightManagementFlow = 'wm1',
  WeightManagementFlowAsync = 'wma',
  WeightManagementFlowInsuranceDiscovery = 'wmi3',
  WeightManagementFlowInsuranceMedications = 'wmbc',
  WeightManagementFlowMedicaid = 'wmm',
  WeightManagementFlowOptavia = 'wm-optavia',
  WeightManagementSpecific = 'wmspec'
}

export enum SignUpSteps {
  AddInsurance = 'add-insurance',
  AdditionalConditions = 'additional-conditions',
  Agreement = 'agreement',
  Allergies = 'allergies',
  AppointmentConfirmation = 'appointment-confirmation',
  BenefitsResult = 'benefits-result',
  BipolarDisorder = 'bipolar-disorder',
  BlueLineIntro = 'blue-line-intro',
  CalculateBMI = 'calculate-bmi',
  CheckMyBenefits = 'check-my-benefits',
  CheckPrescriptionCoverage = 'wm-check-prescription-coverage',
  ChronicDiseases = 'chronic-diseases',
  Confirmation = 'confirmation',
  DobStep = 'dob',
  HealthConditions = 'health-conditions',
  InitialInfo = 'initial-info',
  Insurance = 'insurance',
  InsuranceAppointmentsAndMedications = 'insurance-for-appointments-and-medications',
  InsuranceForAppointments = 'insurance-for-appointments',
  InsuranceForMedications = 'insurance-for-medications',
  InsuranceLowCostOptions = 'insurance-low-cost-options',
  InsuranceMedicationsToBeDiscussed = 'insurance-medications-to-be-discussed',
  InsuranceType = 'insurance-types',
  MarketingCompare = 'compare-to-others',
  MarketingLowerPrice = 'lower-price',
  MarketingMoneyBackGuarantee = 'money-back-guarantee',
  MarketingRatedNumberOne = 'rated-number-one-for-glp-1',
  MarketingRegularMeetings = 'regular-meetings',
  MarketingVideo = 'intro-video',
  MarketingWorkingOnApproval = 'working-on-approval',
  MedicaidWaiver = 'medicaid-waiver',
  Medications = 'medications',
  MifSummary = 'mif-summary',
  NoticeForCalifornia = 'notice-for-california-patients',
  Payment = 'payment',
  PersonalDetails = 'personal-details',
  Pharmacy = 'pharmacy',
  PickVideoOrMessageAppointment = 'pick-appointment-type',
  PlanSelect = 'plan-select',
  PreConfirmation = 'pre-confirmation',
  PreferredMedication = 'preferred-medication',
  Pregnancy = 'wm-pregnancy',
  PreInsurance = 'check-insurance',
  RTBCheckout = 'rtb-checkout',
  SelectLabs = 'select-labs',
  ShouldUseInsurance = 'should-use-insurance',
  SocialHistory = 'social-history',
  State = 'state',
  SwitchToApp = 'switch-to-app',
  TwoOptionsFinish = 'finish-signup',
  UnlockYourResults = 'unlock-your-results',
  UploadBodyPhoto = 'upload-body-photo',
  VerifyIdentity = 'verify-identity',
  VerifyInsurance = 'verify-insurance',
  WithOrWithoutInsurance = 'using-insurance',
  WMAddress = 'wm-address',
  WMAge = 'wm-age',
  WMBasicInfo = 'wm-basic-info',
  WMBloodPressure = 'wm-blood-pressure',
  WMBupropion = 'wm-bupropion',
  WMCheckout = 'wm-checkout',
  WMCompleteOnboarding = 'wm-complete-onboarding',
  WMCongrats = 'wm-congrats',
  WMDiabetesQuestion = 'wm-diabetes-question',
  WMDiabetesTypeOneQuestion = 'wm-diabetes-type-i-question',
  WMDOB = 'wm-dob',
  WMGallbladderQuestion = 'wm-gallbladder-question',
  WMGallStonesQuestion = 'wm-gallstones-question',
  WMGlaucoma = 'wm-glaucoma',
  WMHeightAndWeight = 'height-and-weight',
  WMKetogenicDiet = 'wm-ketogenic-diet',
  WMKidneyStones = 'wm-kidney-stones',
  WMKnowledgeAboutGLP1 = 'wm-knowledge-about-glp-1',
  WMLabWork = 'wm-lab-work',
  WMLacticAcidosis = 'wm-lactic-acidosis',
  WMLiverOrKidneyImpairment = 'wm-liver-or-kidney-impairment',
  WMMAOInhibitors = 'wm-mao-inhibitors',
  WMMedicalConditions = 'wm-medical-conditions',
  WMNewTargetWeight = 'wm-new-target-weight',
  WMPancreatitisQuestion = 'wm-pancreatitis-question',
  WMPhoneNumber = 'wm-phone-number',
  WMPriorSeizures = 'wm-prior-seizures',
  WMScheduleAppointment = 'wm-schedule-appointment',
  WMSetPassword = 'wm-set-password',
  WMSexAtBirth = 'wm-sex-at-birth',
  WMSideEffectsWithMetforminBupropion = 'wm-side-effects-with-metformin-bupropion',
  WMThyroidNodulesQuestion = 'wm-thyroid-nodules-question',
  WMTTResults = 'wm-tt-results',
  WMUserHealthState = 'wm-user-health-state',
  WMWeightLoseAim = 'wm-weight-lose-aim',
  WMWeightLoseWithoutUncertainty = 'wm-weight-lose-without-uncertainty',
  WMWhatNext = 'wm-what-next',
  WMWhyTT = 'wm-why-triple-therapy',
  WMYouAreInGoodHands = 'wm-you-are-in-good-hands',
  WomensHealth = 'womens-health',
  YourWeightLossProgram = 'your-weight-loss-program'
}

export enum FeatureFlag {
  AiAssistantChat = 'wismo-chat',
  /**
   * When enabled, an unverified ID no longer blocks the POMIF scheduling
   * step — the patient can book their sync visit and complete verification
   * later. OFF (the default) keeps the product rule that identity must be
   * verified before scheduling. Only affects the scheduling gate: the
   * Verify ID row still reports its true state and the IDV modal is
   * unchanged.
   *
   * Reaching the gate at all also requires the program to opt in via
   * `featureFlags.allowScheduleWithoutIdv`, which only TRT does today — so
   * turning this on cannot loosen scheduling for WH or ATT.
   */
  AllowPomifTrtScheduleWithoutIdv = 'allow-pomif-trt-schedule-without-idv-patient-portal-web',
  ClickToCall = 'click-to-call',
  DarkMode = 'dark-mode',
  DisableInternalSignups = 'disable-internal-signups',
  DisableScheduleApptOnLabResult = 'disable-schedule-appt-on-lab-result',
  EnableAttFunnelLinks = 'enable-att-funnel-links', // LMD-1394: AT&T Talk to a doctor → Stardust
  EnablePomifDynamicTrt = 'enable-pomif-dynamic-trt-patient-portal-web',
  ExtendedUpgradeFlow = 'extended-migration-to-wm',
  GLPPrescription = 'glp-prescription',
  /**
   * When enabled, removes Safari's Smart App Banner (the `apple-itunes-app` meta tag) site-wide,
   * so a patient following a web link stays in the browser instead of being prompted to
   * install/open the native app. OFF (the default) keeps today's behavior. iOS only — Android's
   * `prefer_related_applications` lives in the static `public/manifest.json`, which cannot read a
   * flag at runtime and is deliberately left alone. This cannot and does not affect app
   * deep-linking — a patient who already has the app installed and opens a universal/deep link is
   * still routed into the app; this flag only removes the *browser-originated* install prompt.
   * See LMD-1472.
   */
  HideAppInstallPrompts = 'hide-app-install-prompts-patient-portal-web',
  InterpreterOnCall = 'interpreter-on-call',
  Labcorp = 'labcorp-labs-feature',
  MedicationDiscussWithProviderOption = 'medication-discuss-with-provider-option',
  MigrateFromSemaglutide = 'migrate-from-semaglutide',
  MigrateFromTirzepatide = 'migrate-from-tirzepatide',
  MultiSelectCancellation = 'multi-select-cancellation-web',
  OnboardingWMScales = 'onboarding-wm-scales',
  OzempicCashPayCardPostOnboarding = 'ozempic-cash-pay-card-post-onboarding',
  Paypal = 'paypal-feature',
  /**
   * Offers the manual/automatic refill switch on an ACTIVE refill timeline
   * (`RefillModeCard`). OFF is the safe default and the deploy gate: the card
   * renders on every ACTIVE timeline, automatic ones included, so with it ON
   * against a BFF that predates lifemd#18247 the mode routes 404 for every
   * patient, and against the new BFF with an old PlanEx they answer an uncoded
   * 400. Turn it on only once PlanEx (pangea#581) and the BFF are both live,
   * and before any sig is set to MANUAL - a manual timeline with this OFF has
   * a working picker but no way back to automatic.
   *
   * It is also where the product question lives: whether every patient should
   * be offered the switch at all is a runtime decision while this exists.
   */
  RefillModeSwitch = 'enable-refill-mode-switch-patient-portal-web',
  /**
   * Gates *creating* a pause on the Manage Medication page: the Pause button and
   * its resume-date picker. OFF hides them and nothing else. A timeline that is
   * already PAUSED keeps its status text and its Resume button, because hiding
   * those would strand the patient with no way back, and Cancel is unaffected.
   */
  RefillPauseResume = 'enable-refill-pause-resume-patient-portal-web',
  RequiredAgreementsEvaluator = 'enable-required-agreements-evaluator-patient-portal-web',
  RequirePomifTrtFullIdUpload = 'require-pomif-trt-full-id-upload-patient-portal-web',
  ServerDrivenProgramProducts = 'server-driven-program-products',
  ShowAttRemoveBenefitButton = 'show-att-remove-benefit-button',
  SuggestedAddress = 'suggested-address',
  VideoRecording = 'video-recording',
  /**
   * LMD-2204: offers LifeMD on-demand as "Be seen ASAP" on pick-a-time. OFF keeps the earlier
   * method screen, where on-demand is its own option.
   */
  WaitingRoomUi = 'waiting-room-ui-patient-portal-web',
  WegovyCardPostOnboarding = 'wegovy-lobby-card-post-onboarding',
  WegovyLobbyCard = 'wegovy-lobby-card',
  WegovyPillCardPostOnboarding = 'wegovypill-card-post-onboarding',
  /**
   * Adds a schedule-appointment step before pharmacy in WH post-onboarding for sync
   * patients who have not booked a WH video visit. OFF (the default) keeps today's step list.
   */
  WHPomifScheduleAppointment = 'wh-pomif-schedule-appointment',
  WHProgressRedesign = 'wh-progress-redesign',
  WHRequireFullIdVerification = 'wh-require-full-id-verification',
  WMAppointmentType = 'wm-appointment-type',
  /**
   * When enabled, WM post-onboarding runs the Vouched cross-check on load for patients who never
   * see the Intro step (intake and address already complete, or a deep link past it). The Intro
   * keeps running its own cross-check either way. OFF (the default) keeps today's behavior.
   * See LMD-2317.
   */
  WMCrosscheckOnLoad = 'wm-crosscheck-on-load-patient-portal-web',
  WMSyncToAsyncDisabled = 'wm-sync-to-async-disabled',
  WorkOSPatientAuth = 'workos-patient-auth',
  ZoomAllowedToSelectDevices = 'zoom-allowed-to-select-devices',
  /**
   * When enabled, Zoom's chat bubble stays hidden on every page and shows only while a Zoom chat is
   * live, which in practice is a chat Lifey handed over with Connect. Zoom stays loaded, so Connect
   * still opens it. OFF (the default) keeps today's bubble.
   */
  ZoomChatEscalationOnly = 'zoom-chat-escalation-only',
  ZoomChatWidget = 'zoom-chat-widget'
}

export enum HealthProfileNavItem {
  AdditionalHealthConditions = 'Additional health conditions',
  Allergies = 'Allergies',
  ChronicDiseases = 'Chronic diseases',
  HealthConditions = 'Health conditions',
  HealthMetrics = 'Health metrics',
  MedicalIntakeForm = 'Medical intake form',
  Medications = 'Medications',
  SocialHistory = 'Social history',
  WomensHealth = "Women's health"
}

export enum PageTitle {
  // MyAccount = 'My account',
  About = 'About',
  AccountInformation = 'Account information',
  AccountSettings = 'Account settings',
  AIAssistantChat = 'New Message',
  Allergies = 'Allergies',
  Back = 'Back',
  BillingCard = 'Billing & card',
  Cart = 'Cart',
  ChangePassword = 'Change password',
  // ChoosePharmacy = 'Choose pharmacy',
  ChoosePlan = 'Change your plan',
  ChronicDiseases = 'Chronic diseases',
  ConfirmPlanChange = 'Confirm plan change',
  CreateNewRequest = 'Create new request',
  // Dashboard = 'Dashboard',
  Documents = 'Documents',
  GetCare = 'Get care',
  HealthConditions = 'Health conditions',
  HealthMetrics = 'Health metrics',
  // UploadDocuments = 'Upload Documents',
  HealthProfile = 'Health profile',
  HipaaAgreement = 'HIPAA Marketing Authorization',
  History = 'History',
  Insurance = 'Insurance',
  LabsImaging = 'Labs & Imaging',
  Legal = 'Legal',
  MedicaidWaiver = 'Medicaid waiver',
  MedicalRecords = 'Medical records',
  Medications = 'Medications',
  Messages = 'Messages',
  MyResources = 'My resources',
  // MyProvider = 'My provider',
  Notifications = 'Notifications',
  PaymentMethod = 'payment method',
  Prescriptions = 'Prescriptions',
  Shop = 'Shop',
  SignInAndSecurity = 'Sign in & security',
  SocialHistory = 'Social history',
  Support = 'Support',
  UpgradePlan = 'Upgrade plan',
  Weight = 'Weight',
  WomensHealth = "Women's health"
  // WMArticle = 'Guide',
  // WeightManagement = 'Weight Management',
}

export type ScreenSizes = 'xl' | 'lg' | '2xl' | 'sm' | 'xs' | 'md';

export enum DeepLinkAction {
  AgreementRequired = 'agreement-required',
  AppointmentDetails = 'appointment-details',
  AppointmentRequired = 'appointment-required',
  AppointmentReschedule = 'appointment-reschedule',
  /** AT&T simplified cancellation, deep-link only — no in-portal entry point (LMD-1124). */
  AttCancel = 'att-cancel',
  /** AT&T unlink sheet; also reachable from the benefit card's "Remove this benefit" button. */
  AttRemoveBenefit = 'att-remove-benefit',
  BillingPastDuePopup = 'billing-past-due-popup',
  /** Lands on Billing details and opens the cancel flow for `programId` (LMD-514). */
  CancelSubscription = 'cancel-subscription',
  CreateAppointment = 'create-appointment-extended',
  Dashboard = 'dashboard',
  DiscountCard = 'discount-card',
  FrontDeskChannel = 'front-desk-channel',
  IntakeForm = 'intake-form',
  Labs = 'labs',
  MedicationRenewal = 'medication-renewal',
  MessageChannel = 'message-channel',
  NewSupportRequest = 'new-support-request',
  NoShowFeeCharged = 'no-show-fee-charged',
  NovocareAgreementRequired = 'novocare-agreement-required',
  // MigrateToBundle = 'migrate-to-bundled', // for wm care only
  Offer = 'offer',
  // Per-type order routing: store/shop orders → `order`; device/scale shipments → `wm-devices-shipment`;
  // lab kits carry an external tracking URL directly (no action).
  Order = 'order',
  PartnerBenefitUnlinked = 'partner-benefit-unlinked',
  PlanRecommendation = 'plan-recommendation',
  PostOnboardingNew = 'async-post-onboarding',
  Program = 'program',
  ProgramOnboarding = 'program-onboarding',
  ResourcesPage = 'resources-page',
  ResumeProgramPaywall = 'resume-program-paywall',
  // Weight-management only (LMD-1401): opens medication selection for a patient with no preferred
  // medication yet. Emitted by the backend's `SELECT_MEDICATION` onboarding blocker.
  SelectMedication = 'select-medication',
  SemaglutideMigration = 'semaglutide-migration',
  Shop = 'shop',
  StoreProduct = 'store_product',
  Survey = 'survey',
  TirzepatideMigration = 'tirzepatide-migration',
  UnpaidInvoice = 'unpaid-invoice',
  UpdateCreditCard = 'update-credit-card',
  /** Opens the body-photo upload modal on Home. */
  UploadBodyPhoto = 'upload-body-photo',
  VerifyIdentity = 'verify-identity',
  WaitingRoom = 'waiting-room',
  WMAddWeight = 'wm-add-weight',
  // Handled component-locally (not in the useDeepLinks switch): `Home` reads this action to open the
  // add-measurement modal.
  WMDevicesNewMeasurements = 'wm-devices-new-measurements',
  // Resolved centrally (useDeepLinks) → the Weight page, where `DeviceShipmentDeepLink` fetches the device
  // order by `orderId` and opens the tracking modal. Mirrors mobile, which switches to the Weight tab and
  // fetches the order the same way, so the link works from anywhere. Requires `orderId`.
  WMDevicesShipment = 'wm-devices-shipment',
  WMWinback = 'wm-winback'
}

export enum DiscoverInsuranceResults {
  Inactive = 'wm-discover-result-inactive',
  NotVerified = 'wm-discover-result-not-verified',
  Success = 'wm-discover-result-success'
}

export enum ReviewProblemType {
  MyProvider = 'my-provider',
  UsingApp = 'using-app'
}

export enum ReviewOrigin {
  Appointment = 'appointment',
  Provider = 'provider'
}

export enum ShippingStatuses {
  // ASH statuses
  AshKitAccessioned = 'ASH_KIT_ACCESSIONED', // kit is received by the lab
  AshKitDeliveredToPatient = 'ASH_KIT_DELIVERED_TO_PATIENT',
  AshKitFulfillmentCanceled = 'ASH_KIT_FULFILLMENT_CANCELED', // Handle same as rejected
  AshKitInTransitToLab = 'ASH_KIT_IN_TRANSIT_TO_LAB',
  AshKitIssue = 'ASH_KIT_ISSUE', // Handle same as rejected
  AshKitRejected = 'ASH_KIT_REJECTED',
  AshOrderFulfilled = 'ASH_ORDER_FULFILLED', // order is on the way to patient
  AshResultsReady = 'ASH_RESULTS_READY',
  AshTestSamplesReceived = 'ASH_TEST_SAMPLES_RECEIVED',
  // END of ASH statuses
  Blocked = 'Blocked',
  Delivered = 'Delivered',
  Exception = 'Exception',
  InProgress = 'In Progress',
  Ordered = 'Ordered',
  Placed = 'Placed',
  Processing = 'Processing',
  Shipped = 'Shipped'
}

export enum EmailStatus {
  Legacy = 'legacy',
  Pending = 'pending',
  Unverified = 'unverified',
  Verified = 'verified'
}

// export enum OrderStatuses {
//   Canceled = 'Canceled',
//   Completed = 'Completed',
//   InProgress = 'In Progress',
//   MissingInfo = 'Missing Info',
//   New = 'New',
//   Pending = 'Pending',
// }

export enum MessageEvent {
  AppointmentCancelled = 'appointmentCancelled',
  AppointmentComplete = 'appointmentComplete',
  AppointmentCreated = 'appointmentCreated',
  AppointmentMissed = 'appointmentMissed'
}
export enum MIFTabs {
  AllAnswers = 'All answers',
  WarningsOnly = 'Warnings only'
}

export enum TaskStatuses {
  // Active = 'Active',
  // Cancelled = 'Cancelled',
  Completed = 'Completed',
  // Deleted = 'Deleted',
  New = 'New'
  // Open = 'Open',
  // Urgent = 'URGENT'
}

export enum MessageTab {
  CareTeam = 'care-team',
  FrontDesk = 'front-desk'
}

export enum TirzepatideMigrationPatientGroup {
  // EligibleForBranded = 'eligible-for-branded',
  // Maintenance = 'maintenance',
  NotEligibleForBranded = 'not-eligible-for-branded'
  // Unknown = 'unknown'
}

export enum SemaglutideMigrationPatientGroup {
  EligibleForBranded = 'eligible-for-branded',
  NotEligibleForBranded = 'not-eligible-for-branded'
}

export enum TirzepatideMigrationPatientAction {
  AcceptedSemaglutide = 'accepted-semaglutide', // User action. Should be sent from the front-end
  AcceptedSemaglutideBundled = 'accepted-semaglutide-bundled', // Based on the plan change
  AcceptedSemaglutideMaintenance = 'accepted-semaglutide-maintenance', // Based on the plan change
  AcceptedTirzepatidePlus = 'accepted-tirzepatide-plus', // Based on the MIF response
  AcceptedTirzepatidePlusBundled = 'accepted-tirzepatide-plus-bundled', // Based on the MIF response
  AcceptedTirzepatidePlusMaintenance = 'accepted-tirzepatide-plus-maintenance', // Based on the MIF response
  AppointmentScheduled = 'appointment-scheduled',
  MovedToBranded = 'moved-to-branded', // Handled outside of the LifeMD system
  RequestedAppointment = 'requested-appointment' // User action. Should be sent from the front-end
}

export enum SemaglutideMigrationPatientAction {
  AcceptedSemaglutidePlus = 'accepted-semaglutide-plus', // Based on the MIF response
  AcceptedSemaglutidePlusBundled = 'accepted-semaglutide-plus-bundled', // Based on the MIF response
  AcceptedSemaglutidePlusMaintenance = 'accepted-semaglutide-plus-maintenance', // Based on the MIF response
  AcceptedTripleTherapy = 'accepted-triple-therapy', // Handled outside of the LifeMD system
  AcceptedWegovy = 'accepted-wegovy', // User action. Should be sent from the front-end
  AppointmentScheduled = 'appointment-scheduled',
  MovedToBranded = 'moved-to-branded', // Handled outside of the LifeMD system
  RequestedAppointment = 'requested-appointment' // User action. Should be sent from the front-end
}

export enum AppointmentListTypes {
  Default = 0,
  MissedByPatient = 1,
  Upcoming = 2,
  Completed = 3,
  Canceled = 4,
  Past = 5
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum MifCode {
  MensHealthRenewal = 'mens-health-renewal',
  MhASQ = 'mh-asq',
  MhGad7 = 'mh-gad-7',
  MhPhq9 = 'mh-phq-9',
  WhRenewal = 'wh-renewal'
}
